var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mpQQ-upload-temp"},[_c('upfile',{attrs:{"name":"上传临时素材","many":1,"action":"api/ysy_common_upfile_with_judge","mul":false,"bus":"abcde","acc":".jpeg,.jpg,.png,.gif,.mp3,.mp4,.xls,.xlsx,.doc,.docx,.ppt,.txt,.xml,.tar,.wps,.zip,.pdf,.pptx","acce":['img','voice','video','excel','doc','ppt','text','tar','wps','zip','pdf']}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4083e214","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ysy/mpQQUpLoadTemp.vue
// module id = null
// module chunks = 